import { gql, useMutation } from '@apollo/client';

export const CREATE_PAYMENT_INTENT = gql`
  mutation createPaymentIntent(
    $customerDetails: StripeCustomerDetailsInputType!
    $amount: Float!
    $locationId: String!
    $studyId: String
  ) {
    createPaymentIntent(
      customerDetails: $customerDetails
      amount: $amount
      locationId: $locationId
      studyId: $studyId
    ) {
      clientSecret
    }
  }
`;

export interface StripeCustomerDetailsInputType {
  name?: string;
  address?: {
    line1?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    state?: string;
  };
}

export const useCreatePaymentIntent = () => {
  const [createPaymentIntent, { loading, error }] = useMutation(CREATE_PAYMENT_INTENT);

  const mutation: any = [
    ({
      customerDetails,
      amount,
      locationId,
      studyId,
    }: {
      customerDetails: StripeCustomerDetailsInputType;
      amount: number;
      locationId: string;
      studyId?: string;
    }) =>
      createPaymentIntent({
        variables: { customerDetails, amount, locationId, studyId },
        context: {
          clientName: 'apps',
        },
      }),
    loading,
    error,
  ];

  return mutation;
};
